import { devtools } from 'config/devtools'
import { TetrisScenarioTabsCodes } from 'modules/tetrisDataSource/interfaces/common'
import { create } from 'zustand'

import { UseTetrisScenarioTab } from './types'

export const useTetrisScenarioTab = create<UseTetrisScenarioTab>()(
  devtools(
    (set) => ({
      currentTab: TetrisScenarioTabsCodes.Input,
      setCurrentTab: (currentTab) => set({ currentTab }),
    }),
    {
      store: 'currentTetrisScenarioTab',
    },
  ),
)
